import ArticleLayout from '@/pages/articles/components/ArticleLayout';

export default function BestChinaAgent() {
  return <ArticleLayout slug="best-china-agent" />;
}